import { ComponentStyleConfig } from '@chakra-ui/react';

export const Checkbox: ComponentStyleConfig = {
  baseStyle: {
    control: {
      borderRadius: 2,
      borderColor: 'M.50',
      _hover: {
        borderColor: 'iconAccent',
        _disabled: {
          borderColor: 'M.50',
        },
      },
      _focus: {
        borderColor: 'iconAccent',
      },
      _checked: {
        bg: 'iconAccent',
        border: 'none',
        _disabled: {
          cursor: 'default',
          color: 'textDisabled',
          bg: 'iconAccent',
          borderColor: 'iconAccent',
        },
        _hover: {
          bg: 'iconAccent',
        },
      },
      _disabled: {
        bg: 'textDisabled',
        opacity: 0.36,
        borderColor: 'M.50',
      },
    },
    container: {
      '&.hasBorder': {
        border: '1px solid',
        borderColor: 'borderBase',
      },
      borderRadius: 4,
      px: 3,
      py: '13px',
      _disabled: {
        cursor: 'default',
      },
      ' svg': {
        color: 'white',
      },
    },
    label: {
      color: 'textBase',
      fontWeight: 'medium',
    },
  },
  sizes: {
    sm: {
      control: {
        w: '20px',
        h: '20px',
      },
      label: {
        fontSize: 'xs',
        lineHeight: '17px',
        letterSpacing: '1.5px',
      },
    },
    md: {
      control: {
        w: '20px',
        h: '20px',
      },
      label: {
        fontSize: 'sm',
        lineHeight: '19px',
        letterSpacing: '0.5px',
        ml: 3,
      },
    },
    lg: {
      control: {
        w: '28px',
        h: '28px',
      },
      label: {
        fontSize: 'md',
        lineHeight: '17px',
        letterSpacing: '0.25px',
      },
    },
  },
};
